import { useState } from "react";
import { Gift, Instagram } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useSite } from "@/context/SiteContext";
import { REWARD_DEFAULTS, formatBRL, instaHandle, instaUrl } from "@/lib/site";

const FloatingReward = () => {
  const { settings } = useSite();
  const [open, setOpen] = useState(false);
  const p = { ...REWARD_DEFAULTS, ...(settings?.reward_program || {}) };
  if (!p.active) return null;
  const handle = instaHandle(p.instagram);
  const amount = Number(p.amount) > 0 ? formatBRL(p.amount) : "";

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="reward-float-btn"
        className="fixed z-40 right-4 bottom-24 md:bottom-6 flex items-center gap-2 rounded-full bg-primary text-primary-foreground pl-3 pr-4 py-3 shadow-lg shadow-primary/30 hover:scale-105 active:scale-95 transition-transform">
        <span className="relative flex">
          <span className="absolute inline-flex h-full w-full rounded-full bg-white/50 animate-ping" />
          <Gift className="relative w-5 h-5" />
        </span>
        <span className="text-sm font-bold">{p.button_label || "Ganhe prêmio"}</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-3xl" data-testid="reward-dialog">
          <DialogHeader>
            <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-2"><Gift className="w-7 h-7 text-primary" /></div>
            <DialogTitle className="text-xl font-heading" data-testid="reward-title">{p.title}</DialogTitle>
            {amount && (
              <DialogDescription asChild>
                <p className="text-3xl font-bold text-primary font-heading" data-testid="reward-amount">{amount}</p>
              </DialogDescription>
            )}
          </DialogHeader>
          {p.rules && (
            <div className="rounded-2xl bg-muted/60 p-4 max-h-[45vh] overflow-y-auto">
              <p className="text-xs font-bold uppercase tracking-wide text-muted-foreground mb-2">Regras</p>
              <p className="text-sm text-foreground leading-relaxed whitespace-pre-line" data-testid="reward-rules">{p.rules}</p>
            </div>
          )}
          {handle && (
            <a href={instaUrl(p.instagram)} target="_blank" rel="noreferrer" data-testid="reward-instagram-btn"
              className="w-full flex items-center justify-center gap-2 rounded-full py-3 font-bold text-white bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF] active:scale-95 transition-transform">
              <Instagram className="w-5 h-5" /> {p.cta_text || "Abrir Instagram"} @{handle}
            </a>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FloatingReward;
